import Amanda1 from '../../../media/fasad/Amanda.webp'
import Amanda2 from '../../../media/fasad/Amanda.webp'


const Amandaimages =[
Amanda1,Amanda2
]

export default Amandaimages;